"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DraftLabel = DraftLabel;
Object.defineProperty(exports, "LabelDetail", {
  enumerable: true,
  get: function get() {
    return _LabelDetail["default"];
  }
});
Object.defineProperty(exports, "LabelPicker", {
  enumerable: true,
  get: function get() {
    return _LabelPicker["default"];
  }
});
Object.defineProperty(exports, "LabelPrompt", {
  enumerable: true,
  get: function get() {
    return _LabelPrompt["default"];
  }
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _chromaJs = _interopRequireDefault(require("chroma-js"));
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("../../utils/constants");
var _hover = require("../../hooks/hover");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _LabelPicker = _interopRequireDefault(require("./LabelPicker"));
var _LabelDetail = _interopRequireDefault(require("./LabelDetail"));
var _LabelPrompt = _interopRequireDefault(require("./LabelPrompt"));
var _excluded = ["theme", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var backgroundAlpha = 0.2;
var MIN_WIDTH = '41px';
var Label = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
    color = _ref.color,
    children = _ref.children,
    theme = _ref.theme,
    onRemove = _ref.onRemove,
    _ref$hoverable = _ref.hoverable,
    hoverable = _ref$hoverable === void 0 ? false : _ref$hoverable,
    _ref$hasBgColor = _ref.hasBgColor,
    hasBgColor = _ref$hasBgColor === void 0 ? true : _ref$hasBgColor,
    _ref$darkModeColor = _ref.darkModeColor,
    darkModeColor = _ref$darkModeColor === void 0 ? _constants.DARK_MODE_COLORS[0] : _ref$darkModeColor;
  var contentRef = (0, _react.useRef)();
  var _useHover = (0, _hover.useHover)(),
    hovered = _useHover.hovered,
    targetProps = _useHover.targetProps;
  var _ref2 = theme || {},
    _ref2$isDarkTheme = _ref2.isDarkTheme,
    isDarkTheme = _ref2$isDarkTheme === void 0 ? false : _ref2$isDarkTheme;
  var _useHover2 = (0, _hover.useHover)(),
    buttonHovered = _useHover2.hovered,
    buttonProps = _useHover2.targetProps;
  var _useMemo = (0, _react.useMemo)(function () {
      var textColor = isDarkTheme ? darkModeColor : (0, _chromaJs["default"])(color && _chromaJs["default"].valid(color) ? color : _constants.COLORS[0]);
      var darkModeBgcolor = (0, _chromaJs["default"])(color && _chromaJs["default"].valid(color) ? color : _constants.COLORS[0]);
      var bgColor = isDarkTheme ? darkModeBgcolor : darkModeBgcolor.alpha(backgroundAlpha);
      return {
        textColor: textColor,
        bgColor: hasBgColor ? bgColor : '',
        btnBgColor: !!bgColor && bgColor.desaturate()
      };
    }, [color, hasBgColor, isDarkTheme, darkModeColor]),
    textColor = _useMemo.textColor,
    bgColor = _useMemo.bgColor,
    btnBgColor = _useMemo.btnBgColor;
  var _useState = (0, _react.useState)({
      // Use `fit-content` to stretch the width on mounted
      minWidth: 'fit-content'
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    widthProps = _useState2[0],
    setWidthProps = _useState2[1];
  (0, _react.useEffect)(function () {
    var content = contentRef.current;
    if (content && hoverable) {
      // Set the fixed width when hoverable to avoid CLS
      setWidthProps({
        width: content.clientWidth + 1
      });
    }
  }, [hoverable]);
  var showButton = hovered && !!onRemove;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, hoverable ? targetProps : {}, {
    ref: ref,
    className: (0, _classnames["default"])('font-bold rounded overflow-hidden inline-flex justify-center items-center h-6 select-none text-xs', className),
    style: _objectSpread(_objectSpread({
      minWidth: MIN_WIDTH
    }, widthProps), {}, {
      color: textColor,
      backgroundColor: bgColor
    }),
    title: children
  }), /*#__PURE__*/_react["default"].createElement("span", {
    ref: contentRef,
    className: (0, _classnames["default"])('truncate', {
      'pl-2 pr-1': !!showButton,
      'px-2': !showButton
    }),
    style: {
      maxWidth: '10rem'
    }
  }, children), /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, hoverable ? buttonProps : {}, {
    className: "h-full",
    style: {
      backgroundColor: buttonHovered && showButton && btnBgColor
    }
  }), showButton && /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onRemove,
    className: "px-1 flex items-center h-full"
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    fontSize: "inherit"
  }))));
});
function DraftLabel(_ref3) {
  var theme = _ref3.theme,
    children = _ref3.children,
    prop = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var color = (0, _chromaJs["default"])(_constants.DRAFTS_COLOR.LIGHT);
  return /*#__PURE__*/_react["default"].createElement(Label, (0, _extends2["default"])({}, prop, {
    className: "mr-1 text-lg align-bottom",
    darkModeColor: _constants.DRAFTS_COLOR.DARK,
    hasBgColor: false,
    customBgColor: color.alpha(backgroundAlpha),
    color: color
  }), children);
}
var _default = exports["default"] = Label;
//# sourceMappingURL=index.js.map